<template>
  <d-container fluid class="main-content-container p-4">
    <!-- --- COLLAPSE --- --- -- -->
    <div>
      <b-button v-b-toggle.collapse-2 class="m-1 greenbutton"><i class="fas fa-filter mr-2 "></i> Filtrer le tableau
      </b-button>
      <!-- Element to collapse -->
      <b-collapse id="collapse-2" class="mb-4">
        <d-card class="card-small">
          <d-card-body class="px-4 pb-0">
            <d-input-group class="justify-content-center">
              <c-input type="price" class="w-25" label="Tolérance" currency="XAF"
                       v-model="inconsistencyMargin"/>
              <c-button-spinner class="inline-btn ml-1 mt-3" variant="primary" :fetching="fetchingSearch"
                                @click="onSearchSubmit">
                <template slot="icon">
                  <i class="fa fa-search"></i>
                </template>
                Rechercher
              </c-button-spinner>
            </d-input-group>
          </d-card-body>
        </d-card>
      </b-collapse>
    </div>
    <d-card class="card-small">
      <d-card-header class="px-4 pb-0">
        <d-input-group class="justify-content-center">
          <c-input class="w-25" placeholder="Rechercher par nom ou clé publique..." v-model="search"></c-input>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="filteredData" :fields="fields" :actions="actions" :per-page="25">
          <p class="text-center" slot="empty">Aucun service incohérent trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, formatAmount, Toast} from "@/helpers"

export default {
  title: "Incohérence des services",
  data() {
    return {
      search: '',
      inconsistencyMargin: 0,
      fetchingSearch: false,
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'logo', label: 'Logo'},
        {key: 'entity', label: 'Nom du service', sortable: true},
        {key: 'public_key', label: 'Clé publique', sortable: true},
        {key: 'created_at_pretty', label: 'Créé le', sortable: true},
        {key: 'status', label: 'Statut', sortable: true},
        {key: 'balance_pretty', label: 'Solde', sortable: true},
        {key: 'expected_pretty', label: 'Solde calc.', sortable: true},
        {key: 'difference_pretty', label: 'Diff.', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {
          type: 'white',
          icon: 'fas fa-exchange-alt',
          title: "Transactions du service",
          handler: this.onRedirectToTransaction
        },
        {
          type: 'white',
          icon: 'fas fa-sync',
          title: "Synchroniser le solde",
          handler: this.onSync
        },
      ],
    }
  },
  computed: {
    filteredData() {
      const search = this.search.toLowerCase()
      return this.data.filter(item => {
        return item.entity.toLowerCase().includes(search)
          || item.balance.toLowerCase().includes(search)
          || item.expected.toLowerCase().includes(search)
          || item.difference.toLowerCase().includes(search)
          || item.public_key.toLowerCase().includes(search)
      })
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/scan/services')
      .then(res => this.data = res.data.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        logo: item.logo_url,
        balance_pretty: formatAmount(item.balance),
        created_at_pretty: item.created_at,
        _rowVariant: item.deleted === true ? 'secondary' : '',
        status: item.enabled ? "Actif" : item.identity_file ? "En attente..." : "Inactif",
        statusVariant: item.enabled ? "success" : item.identity_file ? "warning" : "secondary",
        expected_pretty: formatAmount(item.expected),
        difference_pretty: formatAmount(item.difference),
      }
    },
    onSearchSubmit() {
      this.fetchingSearch = true
      Api.postFormData('/scan/services', {margin: this.inconsistencyMargin})
        .then(res => this.data = res.data.map(this.mapItem))
        .catch(err => this.error = err)
        .then(() => this.fetchingSearch = false)
    },
    // Redirect to service's transactions
    onRedirectToTransaction(item) {
      this.$router.push({name: 'transactions', query: {entity: 'SERVICE', id: item.id}});
    },
    // Sync service's balance
    onSync(item) {
      Toast.loading(`Synchronisation du solde du service "${item.entity}"...`)
      Api.postFormData('/sync_balance/service', {service_id: item.id})
        .then(res => {
          const service = res.data.service
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`Le solde du service "${service.name}" a été synchronisé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
  }
}
</script>

<style scoped>
.logo {
  max-height: 50px;
}

.table-logo {
  max-height: 24px;
  max-width: 100%;
}

.table tr td label, .table tr td .form-group {
  margin: 0;
}
</style>
